moya.map = window.moya.map || {};
moya.map = $.extend(moya.map, {
	createMap: function ($element, options) {
		var opts = moya.map.getMapOptions(options);
		var el = $element.get(0);
		var map = L.map(el, opts).setView(opts.center, opts.zoom);

		L.tileLayer.wms('https://gis.lmi.is/mapcache/web-mercator/wms?', {
			attribution: '&copy; <a href="https://www.lmi.is" target="_blank">LMÍ</a>',
			layers: 'LMI_Kort',
		}).addTo(map);
		L.tileLayer.wms('https://gis.lmi.is/geoserver/wms?', {
			layers: 'Ornefni',
			transparent: true,
			format: 'image/png',
			version: '1.3.0',
		}).addTo(map);

		if (opts.useZoomControl) {
			map.zoomControl.setPosition(opts.zoomControlPosition);
		}

		moya.map.osmMap = map;
		moya.map.markers = this.addMarkers(opts.markers, map, opts);

		if (opts.markers && opts.autoCenter) {
			this.fitMarkers();
		}
		$element.data('moyaMap', map);
		return map;
	},
});
